var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintedDeliveryTickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x33_8_Printer_Print_Paper_Photo_Ink_Color_Polygraphy"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c2cde7",
    d: "M58,45H6c-1.7,0-3-1.3-3-3V18c0-1.7,1.3-3,3-3h52c1.7,0,3,1.3,3,3v24C61,43.7,59.7,45,58,45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#acb7d0",
    d: "M58,45H6c-1.7,0-3-1.3-3-3v-6c0-1.7,1.3-3,3-3h52c1.7,0,3,1.3,3,3v6C61,43.7,59.7,45,58,45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bbdef9",
    d: "M41.8,59H16c-1.7,0-3-1.3-3-3V39h38v10.8c0,0.8-0.3,1.6-0.9,2.1l-6.2,6.2C43.3,58.7,42.6,59,41.8,59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#def0ff",
    d: "M50 52.1L50 39.6 35 58.6 43 58.6zM20.6 58.6L36.2 38.9 34.7 38.9 19.1 58.6zM29.6 58.6L45.2 38.9 40.7 38.9 25.1 58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 47.2L21.2 49.5 23.5 50.7 21.2 52 20 54.2 18.8 52 16.5 50.7 18.8 49.5zM30.7 42L31.5 43.6 33.1 44.4 31.5 45.3 30.7 46.8 29.8 45.3 28.2 44.4 29.8 43.6zM38.5 48.8L39.1 49.8 40.2 50.4 39.1 51 38.5 52.1 38 51 36.9 50.4 38 49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffefb8",
    d: "M43 59L43 51 51 51zM55 25H61V33H55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faefde",
    d: "M49 15L15 15 18 5 46 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dce5f5",
    d: "M56,20L56,20c0,0.6-0.4,1-1,1H17c-0.6,0-1-0.4-1-1v0c0-0.6,0.4-1,1-1h38C55.6,19,56,19.4,56,20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f75f83",
    d: "M7 19H11V22H7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M12 21v-1c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2h2C11.1 23 12 22.1 12 21zM10 21H8v-1h2V21zM6 27c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1 .6 0 1-.4 1-1v-2C7 27.4 6.6 27 6 27zM11 27c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1 .6 0 1-.4 1-1v-2C12 27.4 11.6 27 11 27zM16 27c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1 .6 0 1-.4 1-1v-2C17 27.4 16.6 27 16 27zM21 27c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1 .6 0 1-.4 1-1v-2C22 27.4 21.6 27 21 27zM26 27c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1 .6 0 1-.4 1-1v-2C27 27.4 26.6 27 26 27zM31 27c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1 .6 0 1-.4 1-1v-2C32 27.4 31.6 27 31 27zM36 27c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1 .6 0 1-.4 1-1v-2C37 27.4 36.6 27 36 27zM41 27c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1s1-.4 1-1v-2C42 27.4 41.6 27 41 27zM51 27c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1s1-.4 1-1v-2C52 27.4 51.6 27 51 27zM46 27c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1s1-.4 1-1v-2C47 27.4 46.6 27 46 27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M59,14h-9.2l-1.4-6.8C48,5.3,46.4,4,44.5,4H19.4c-1.9,0-3.5,1.4-3.9,3.2L14.1,14H11H5c-1.7,0-3,1.3-3,3v26 c0,0.8,0.3,1.6,0.9,2.1C3.5,45.7,4.2,46,5,46h7v11c0,0.8,0.3,1.6,0.9,2.1c0.6,0.6,1.3,0.9,2.1,0.9h27.6c0.5,0,1-0.2,1.4-0.6 l7.4-7.4c0.4-0.4,0.6-0.9,0.6-1.4V46h7c0.8,0,1.6-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1V17C62,15.3,60.7,14,59,14z M44,56.6V52 h4.6L44,56.6z M50,50h-6c-0.5,0-1,0.2-1.4,0.6C42.2,51,42,51.5,42,52v6H15c-0.3,0-0.5-0.1-0.7-0.3C14.1,57.5,14,57.3,14,57V40h36 V50z M60.1,24h-4c-0.5,0-1,0.2-1.4,0.6c-0.4,0.4-0.6,0.9-0.6,1.4v6c0,0.5,0.2,1,0.6,1.4c0.4,0.4,0.9,0.6,1.4,0.6h4v9 c-0.1,0.3-0.2,0.5-0.4,0.7S59.3,44,59,44h-7v-4h3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1h-4H13H9c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h3v4 H5c-0.3,0-0.5-0.1-0.7-0.3C4.1,43.5,4,43.3,4,43V17c0-0.6,0.4-1,1-1h6h4h29c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H16.2l1.3-6.4 c0.2-0.9,1-1.6,2-1.6h25.1c1,0,1.8,0.7,2,1.6l1.5,7.6c0.1,0.5,0.5,0.8,1,0.8h10c0.6,0,1,0.4,1,1V24z M60,26v6h-4v-6H60z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintedDeliveryTickets);
export default __webpack_public_path__ + "static/media/printedDeliveryTickets.68851d5e96324a2f8704ecddda0af392.svg";
export { ForwardRef as ReactComponent };